import { getEnvApiMode, getEnvApiUrl, getEnvApiUrls, getEnvOAuth2ClientId } from "./env";

enum ApiMode {
  PROD = "production",
  TEST = "test",
  DEV = "dev",
  ESCAET = "escaet",
  LOCAL = "local",
  IP = "ip",
  ABO = "abo",
  DRO = "dro",
}
const IP = "192.168.1.65";

export let API_MODE = getEnvApiMode() ?? ApiMode.PROD; // use .env => REACT_APP_API_MODE=local
const getUrl = () => new URL(window.location.href);

// Source: react-boilerplate => https://github.com/react-boilerplate/react-boilerplate  (app/utils/request.js)

/**
 * Build backend url
 *
 * @returns {string} Returns a url as string
 */
const buildApiBaseUrl = (protocol: string) => {
  const url = getUrl();
  return `${protocol}//api.${url.hostname}`;
};

/**
 * Get the url from env variables if exists
 *
 * @returns {string} Returns a url as string
 */
const getApiUrlFromEnvironmentVariable = (): string | undefined => {
  const url = getUrl();
  const envApiUrls = getEnvApiUrls();
  let result: string | undefined;
  Object.keys(envApiUrls).forEach((k) => {
    const hostname = k;
    if (hostname && url.hostname.match(hostname)?.length) {
      result = envApiUrls[k];
    }
  });
  return result ?? getEnvApiUrl();
}

/**
 * Get the current backend base (root) url
 *
 * @returns {string} Returns a url as string
 */
export const getHttpApiBaseUrl = () => {
  if (API_MODE === ApiMode.ABO) return "https://abo.dev.kalyzee.com/606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.DRO) return "https://dro-1.dev.kalyzee.com/606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.LOCAL) return "http://localhost:8080/606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.IP) return `http://${IP}:8080/606ee9c4bf11b4001c9ac54b`;
  if (API_MODE === ApiMode.TEST) return "https://api.escaet.kast.app";
  if (API_MODE === ApiMode.DEV) return "https://api.kescaet.dev.kast.app";
  if (API_MODE === ApiMode.ESCAET) return "https://api.escaet.dev.kast.app";
  const url = getUrl();
  const envApiUrl = getApiUrlFromEnvironmentVariable();
  if (envApiUrl) return envApiUrl;
  return buildApiBaseUrl(url.protocol);
};

export const getWebsocketApiBaseUrl = () => {
  const url = getUrl();
  const envApiUrl = getApiUrlFromEnvironmentVariable();
  if (envApiUrl) {
    const urlObj = new URL(envApiUrl);
    // Keep same security level : http -> ws & https -> wss
    urlObj.protocol = urlObj.protocol.replace("http", "ws");
    return urlObj.href;
  }
  // Keep same security level : http -> ws & https -> wss
  return `${buildApiBaseUrl(url.protocol.replace("http", "ws"))}`;
};

export const getUserWebsocketApiBaseUrl = () => {
  if (API_MODE === ApiMode.ABO) return "https://abo.dev.kalyzee.com/user?organization=606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.DRO) return "https://dro-1.dev.kalyzee.com/user?organization=606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.LOCAL) return "http://localhost:8080/user?organization=606ee9c4bf11b4001c9ac54b";
  if (API_MODE === ApiMode.IP) return `http://${IP}:8080/user?organization=606ee9c4bf11b4001c9ac54b`;
  if (API_MODE === ApiMode.TEST) return "https://api.escaet.kast.app/";
  if (API_MODE === ApiMode.DEV) return "https://api.kescaet.dev.kast.app/user";
  if (API_MODE === ApiMode.ESCAET) return "https://api.escaet.dev.kast.app/user";
  const url = new URL(getWebsocketApiBaseUrl());
  url.pathname = `${url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`}user`;
  // Keep same security level : http -> ws & https -> wss
  return url.href;
};

export const getOAuth2ClientId = (): string | undefined => {
  if (API_MODE === ApiMode.LOCAL) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.IP) return `64b03bc1a0733b00129a8e96`;
  if (API_MODE === ApiMode.TEST) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.DEV) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.ESCAET) return "64b03bc1a0733b00129a8e96";
  return getEnvOAuth2ClientId();
};
